module.exports = __webpack_public_path__ + "media/volvo/assets/images/app_store@2x-97a548e53fd4e0a5faa105376e0e89ff.png";